<template>
  <div id="productAcs">
    <div class="row py-3 px-3">
      <h1 class="text-title text-white mt-4 text-end">Our Products</h1>
      <div class="row row-cols-2 ms-3 mb-5 d-flex justify-content-center">
        <template v-for="(ct, key) in content">
          <div class="card col-lg-3 col-md-3 col-sm-3 ms-5 me-5" :key="key">
            <img :src="ct.imgUrl" class="card-img-250-top product-img" alt="..." />
            <div class="card-img-overlay w-auto d-flex justify-content-center">
              <a :href="ct.link" class="card-link">{{ ct.text }}</a>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductPage",

  data: () => ({
    content: [
      {
        imgUrl: "/img/fucsh-oil2.png",
        text: "OIL & GREASE",
        link: "/OilFuchsProd",
      },
      {
        imgUrl: "/img/linde fork.png",
        text: "FORKLIFT RENTAL",
        link: "/ForkliftProd",
      },
      // {
      //   imgUrl: "/img/TYRE.png",
      //   text: "TIRES",
      //   link: "/TyresProd",
      // },
    ],
  }),
};
</script>

<style lang="scss">
// #productAcs .bg {
//   margin-right: -30px;
//   margin-left: -30px;
//   padding-bottom: 3rem !important;
//   padding-top: 3rem !important;
//   background: #000000;
//   clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0 100%);
// }

.product-img {
  height: 100%;
}

#productAcs .card {
  margin-top: 5%;
  margin-bottom: 5%;
}

#productAcs .card-link {
  font-family: Montserrat;
  position: absolute;
  top: 0%;
  bottom: 0%;
  color: rgb(0, 0, 0, 0.9);
  font-size: 24px;
  font-weight: bold;
  padding: 5%;
  text-align: center;
  line-height: 2rem;
}

#productAcs .text-title {
  font-size: 48px;
  font-weight: bolder;
}

#productAcs .card {
  -webkit-transition: all 2s ease;
  transition: all 2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
}

#productAcs .card:hover {
  opacity: 10;
  -webkit-transform: scale(1.15);
  -moz-transform: scale(1.15);
  -ms-transform: scale(1.15);
  -o-transform: scale(1.15);
  transform: scale(1.15);
}

@media screen and (max-width: 640px) {
  #productAcs .text-title {
    font-size: 25px;
  }

  #productAcs .card-link {
    font-size: 1rem;
    line-height: 1em;
  }
}
.card-link{
  text-decoration: none;
}
</style>
